export default __webpack_public_path__ + "static/media/whiteCancel.e8e54fa2.svg";